export const isNotEmpty = <T>(v?: T) => v !== null && v !== undefined && v !== '';
